import { UserInformation } from '../../../api/it/account/account-api-state';
import { useCreateUser } from '../../../hooks/actions/use-create-user';
import TableEmpty from '../../ui/table-empty';
import TableError from '../../ui/table-error';
import TableLoading from '../../ui/table-loading';

interface Props {
    isLoading: boolean;
    isError: boolean;
    errorMessage: string;
    data: UserInformation[];
}

export default function UserListTbody({ isLoading, isError, errorMessage, data }: Props) {
    
    const { handleSelectUser } = useCreateUser()

    return (
        <tbody className="divide-y divide-gray-100">
            { isLoading ? (
                <TableLoading />
            ) : isError ? (
                <TableError description={errorMessage}/>
            ) : data.length === 0 ? (
                <TableEmpty />
            ) : (
                data.map((user, index) => {
                    const fullName = [user.firstname, user.middlename?.[0], user.lastname, user.suffix].filter(Boolean).join(' ');
                    const status = user.is_active  ? 'Active' : 'Inactive'
                    const statusStyle = user.is_active  ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                    return (
                        <tr 
                            onClick={() => handleSelectUser(user.user_id)} 
                            key={user.user_id} 
                            className={`group cursor-pointer border-b border-gray-100 text-xs transition-colors duration-150 hover:bg-[#186cb2]/5 ${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50/60' }`}
                        >
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={fullName}>
                                    <span className={`${statusStyle} inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-medium`}>
                                        <span className="h-1.5 w-1.5 rounded-full bg-current" />
                                        {status}
                                    </span>
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={fullName}>
                                    {fullName}
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={user.email}>
                                    {user.email}
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={user.agent_code}>
                                    {user.agent_code}
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={user.position ?? ''}>
                                    {user.position}
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={user.department?.name}>
                                    {user.department?.name}
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={user.role?.name}>
                                    {user.role?.name}
                                </div>
                            </td>
                            <td className='px-3 py-3 text-gray-700 sm:px-4'>
                                <div className="max-w-[180px] truncate" title={user.reporting_to?.name}>
                                    {user.reporting_to?.name}
                                </div>
                            </td>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
